import { RightCircleFilled } from '@ant-design/icons';
import { Col, Row } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { Store } from 'antd/lib/form/interface';
import { ValidateErrorEntity } from 'rc-field-form/lib/interface';
import React, { useContext, useState } from 'react';

import AnchorComponent from 'components/atoms/AnchorComponent';
import ButtonComponent from 'components/atoms/ButtonComponent';
import InputComponent from 'components/atoms/InputComponent';
import Paragraph from 'components/atoms/Paragraph';
import Title from 'components/atoms/Title';
import AuthWrapper from 'components/base/AuthWrapper';
import { Context } from 'components/hoc/Store';
import TranslateText from 'components/hoc/TranslateText';
import FormWrapper from 'components/molecules/FormWrapper';

import useNavigateWorkaround from 'hooks/useNavigateWorkaround';

import { leiMigraceObnoveniApi } from 'services/lei/leiLogin';

import { emailValidation } from 'utils/validations/emailValidation';
import { validateLEI } from 'utils/validations/leiValidation';

interface IRegistrace {}

const ZadostObnovaHesla: React.FC<IRegistrace> = () => {
    const [form] = useForm();
    const { navigateWorkaround } = useNavigateWorkaround();
    const { prevPath } = useContext(Context);
    const [loading, setLoading] = useState<boolean>(false);
    const [isSubmit, setSubmit] = useState<boolean>(true);

    const onFinish = (value: Store) => {
        setLoading(true);
        leiMigraceObnoveniApi({
            lei: value.lei,
            email: value.email
        }).finally(() => {
            setLoading(false);
            setSubmit(false);
        });
    };
    return (
        <AuthWrapper>
            {isSubmit ? (
                <FormWrapper
                    outForm={form}
                    onFinish={onFinish}
                    onFinishFailed={(err: ValidateErrorEntity) => console.log('chyba:', err)}
                >
                    <Title text="ZAPOMENUTE_HESLO_LEI_TITLE" level={3} />
                    <Paragraph
                        text="ZAPOMENUTE_HESLO_LEI_SUB"
                        style={{
                            display: 'block',
                            marginBottom: 10
                        }}
                    />
                    <InputComponent
                        label="LEI_VELKE"
                        name="lei"
                        type="text"
                        rules={[
                            () => ({
                                validator(_, value: string) {
                                    if (!value || /^\d{10}$/.test(value) || validateLEI(value) === 0)
                                        return Promise.resolve();

                                    return Promise.reject(<TranslateText>NEVALIDNI_LEI_VS</TranslateText>);
                                }
                            })
                        ]}
                    />
                    <InputComponent label="EMAIL" name="email" type="email" rules={emailValidation()} />
                    <Row className="button-row">
                        <Col>
                            <AnchorComponent link={true} to={prevPath.split('#').join('')}>
                                <ButtonComponent buttontext="ZPET" id="leiObnovaZpetBtn" type="default" />
                            </AnchorComponent>
                        </Col>
                        <Col>
                            <ButtonComponent
                                buttontext="ODESLAT"
                                id="leiObnovaSubmitBtn"
                                onClick={() => form.submit()}
                                icon={<RightCircleFilled />}
                                loading={loading}
                            />
                        </Col>
                    </Row>
                </FormWrapper>
            ) : (
                <>
                    <Row justify="center">
                        <h1>
                            <TranslateText>ZAPOMENUTE_HESLO_LEI_TITLE</TranslateText>
                        </h1>
                    </Row>
                    <Row justify="center">
                        <Paragraph
                            style={{
                                paddingBottom: 24,
                                textAlign: 'center'
                            }}
                            text={'ZAPOMENUTE_HESLO_LEI_SENT'}
                        />
                    </Row>
                    <Row justify="center">
                        <ButtonComponent
                            buttontext="ZPET"
                            onClick={() => navigateWorkaround(prevPath.split('#').join(''))}
                            id="leiObnovaRedirectBtn"
                        />
                    </Row>
                </>
            )}
        </AuthWrapper>
    );
};

export default ZadostObnovaHesla;
